import { createContext } from "react";
import type { Tracker } from "./tracker";

export const ZephrContext = createContext<Tracker>(null as never);
